import {filter} from 'lodash';
import {useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {Card, Icon} from 'components';
import {TRANSLATION_KEYS} from 'locale';
import {BillingAddress} from 'types';
import {countryUtils, sessionUtils} from 'utils';

import {EditBillingAddressModal} from './EditBillingAddressModal';

const T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.BILLING.BILLING_ADDRESS;

type Props = {
    billingAddress: BillingAddress;
    onChange: () => void;
}

export const BillingAddressSection: React.FC<Props> = ({billingAddress, onChange}) => {
    const {t} = useTranslation();
    const [editModalProps, setEditModalProps] = useState<{
        open: boolean,
        billingAddress?: BillingAddress
    }>({open: false});

    const renderAddress = useCallback(() => filter([
        billingAddress.line1,
        billingAddress.line2,
        billingAddress.city,
        billingAddress.state,
        billingAddress.zip,
        countryUtils.getNameByCode(billingAddress.country)
    ]).join(', '), [billingAddress]);

    const handleEditModalOpen = useCallback(() => {
        setEditModalProps({open: true, billingAddress});
    }, [billingAddress]);

    const handleEditModalClose = useCallback((success: boolean) => {
        if (success) {
            onChange();
        }
        setEditModalProps({open: false});
    }, [onChange]);

    return (
        <Card className='tw-my-4'>
            <div className='tw-flex tw-justify-between tw-items-center tw-mb-4'>
                <div className='tw-ts-h3-bold -md:tw-ts-h5-bold'>{t(T_KEYS.TITLE)}</div>
                <Icon name='edit' primary button group onClick={handleEditModalOpen} />
            </div>

            <div className='tw-font-bold tw-flex tw-items-center tw-mb-2'>
                <Icon name='user' className='tw-mr-2' />
                {sessionUtils.getParticipantName(billingAddress)}
            </div>
            <div className='tw-flex tw-items-center'>
                <Icon name='map-pin' className='tw-mr-2' />
                {renderAddress()}
            </div>
            <EditBillingAddressModal {...editModalProps} onClose={handleEditModalClose} />
        </Card>
    );
};